import {
  init_collisionCoordinator
} from "./chunk-RRHCXXIN.mjs";
import {
  PointerEventTypes,
  init_pointerEvents
} from "./chunk-XEBZFSO2.mjs";
import {
  Vector2,
  init_math_vector
} from "./chunk-KXFHISWH.mjs";

// src/modules/core/FreeCameraKeyboardWalkInput.ts
init_math_vector();
init_pointerEvents();
init_collisionCoordinator();
var FreeCameraKeyboardWalkInput = class {
  constructor() {
    this.camera = null;
    this.previousPosition = null;
    this.touchEnabled = true;
    this.buttons = [0, 1, 2];
    this.angle = { x: 0, y: 0 };
    this.cameraMinFov = 0.2;
    this.cameraMaxFov = 1.5;
    this.lastPoint = new Vector2(0, 0);
    this.prevDiff = -1;
    this.curDiff = 0;
    this.zoomValue = 0.05;
    this.isPinch = false;
  }
  attachControl() {
    if (!this.camera)
      return console.error("Camera Search is null");
    const element = this.camera.getEngine().getInputElement();
    if (!element)
      return console.error("Element is null");
    this.observer = this.camera.getScene().onPointerObservable.add((eventData) => {
      this.pointerInput(eventData);
    }, PointerEventTypes.POINTERDOWN | PointerEventTypes.POINTERUP | PointerEventTypes.POINTERMOVE);
    element.focus();
  }
  detachControl() {
    if (!this.camera)
      return console.error("Camera Search is null");
    const element = this.camera.getEngine().getInputElement();
    if (this.observer && element) {
      this.camera.getScene().onPointerObservable.remove(this.observer);
      this.observer = null;
      this.previousPosition = null;
      element.removeEventListener("wheel", this.fovChange);
      element.removeEventListener("touchstart", this.mobileSetInitPoint);
      element.removeEventListener("touchmove", this.mobilePinch);
      element.removeEventListener("touchend", this.pinchEnd);
    }
  }
  getClassName() {
    return "FreeCameraSearchInput";
  }
  getSimpleName() {
    return "MouseSearchCamera";
  }
  pointerInput(p) {
    if (!this.camera)
      return console.error("Camera is null");
    const evt = p.event;
    if (this.isPinch)
      return;
    if (!this.touchEnabled && evt.pointerType === "touch") {
      return;
    }
    if (p.type !== PointerEventTypes.POINTERMOVE && this.buttons.indexOf(evt.button) === -1) {
      return;
    }
    if (p.type === PointerEventTypes.POINTERDOWN) {
      this.previousPosition = {
        x: evt.clientX,
        y: evt.clientY
      };
      evt.preventDefault();
    } else if (p.type === PointerEventTypes.POINTERUP) {
      this.previousPosition = null;
      evt.preventDefault();
    } else if (p.type === PointerEventTypes.POINTERMOVE) {
      if (!this.previousPosition) {
        return;
      }
      const offsetX = evt.clientX - this.previousPosition.x;
      const offsetY = evt.clientY - this.previousPosition.y;
      this.angle.x += offsetX;
      this.angle.y -= offsetY;
      this.angle.x -= offsetX;
      this.angle.y += offsetY;
      if (this.camera.getScene().useRightHandedSystem) {
        this.camera.cameraRotation.y -= offsetX / this.camera.angularSensibility;
      } else {
        this.camera.cameraRotation.y += offsetX / this.camera.angularSensibility;
      }
      this.camera.cameraRotation.x += offsetY / this.camera.angularSensibility;
      this.previousPosition = {
        x: evt.clientX,
        y: evt.clientY
      };
      evt.preventDefault();
    }
  }
  fovChange(evt) {
    if (!this.camera)
      return console.error("Camera is null");
    if (evt.deltaY < 0 && this.camera.fov > this.cameraMinFov) {
      this.camera.fov -= this.zoomValue;
    } else if (evt.deltaY > 0 && this.camera.fov < this.cameraMaxFov) {
      this.camera.fov += this.zoomValue;
    }
    evt.preventDefault();
  }
  mobileSetInitPoint(evt) {
    this.lastPoint = new Vector2(
      evt.targetTouches[0].clientX,
      evt.targetTouches[0].clientY
    );
    evt.preventDefault();
  }
  mobilePinch(evt) {
    if (evt.targetTouches.length === 2 && this.camera) {
      this.isPinch = true;
      this.curDiff = Math.abs(
        evt.targetTouches[0].clientX - evt.targetTouches[1].clientX
      );
      if (this.prevDiff > 0) {
        if (this.curDiff > this.prevDiff && this.camera.fov > this.cameraMinFov) {
          this.camera.fov -= this.zoomValue;
        } else if (this.curDiff < this.prevDiff && this.camera.fov < this.cameraMaxFov) {
          this.camera.fov += this.zoomValue;
        }
      }
      this.prevDiff = this.curDiff;
      evt.preventDefault();
    }
  }
  pinchEnd(evt) {
    if (evt.targetTouches.length === 0) {
      this.isPinch = false;
    }
  }
};

export {
  FreeCameraKeyboardWalkInput
};
